import React from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {AnalyticsWidgetsPageWidgetTypesEnum} from '../../../models/api/analyticsWidgetsPageModel';
import {AnalyticsSavedView} from '../../../store/panels/analytics/views/analyticsPanelViewsState';

/*
 * Helpers.
 */

export function renderSupportReportMetricView(view?: AnalyticsSavedView) {
  if (view) {
    return view.name;
  }
  return (
    <Trans id="analytics-automation-reports-support-report-deleted-view-selected">
      Deleted view selected
    </Trans>
  );
}

export function renderSupportReportType(type: AnalyticsWidgetsPageWidgetTypesEnum) {
  switch (type) {
    case AnalyticsWidgetsPageWidgetTypesEnum.RESPONSE:
      return (
        <Trans id="analytics-automation-reports-support-report-average-response-time">
          Average Response Time
        </Trans>
      );
    case AnalyticsWidgetsPageWidgetTypesEnum.FIRST_RESPONSE:
      return (
        <Trans id="analytics-automation-reports-support-report-first-response-time">
          First Response Time
        </Trans>
      );
    case AnalyticsWidgetsPageWidgetTypesEnum.CSAT:
      return <Trans id="analytics-automation-reports-support-report-csat">CSAT</Trans>;
    default:
      return null;
  }
}
